exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-encoded[data-v-32ebf8f0] {\n  border: 2px solid #cad0d7;\n  border-radius: 5px;\n}\n", ""]);

// exports
